import React, { Component } from 'react';
import FilteredList2 from './filteredList2';
import PlanForm from './planForm';
import { end_point } from './helper';


class Plans extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labelFields: [
        { "displayName":"Plan Name", "name":"plan_name", "size": "40%"},
        { "displayName":"Plan Price", "name":"plan_price", "size": "60%"}     
      ],
      filterableFields: ["plan_name", "plan_price"],
      endpoint: `${end_point()}/plans`
    }
  }

  render() {
    return(
      <FilteredList2 heading="Plans"
        filterableFields={this.state.filterableFields} 
        labelFields={this.state.labelFields} 
        endpoint={this.state.endpoint}
        modalClassName="plans-modal">
        <PlanForm />
      </FilteredList2>
    );
  }
}

export default Plans;
